import { Dayjs } from 'dayjs';

import { SDate } from '@summit/core';

import { Employee } from '../employee/employee';
import { EboEvent } from './ebo-event';

export class EboEventTo extends EboEvent {
  modifiedOn: Dayjs;
  modifiedBy?: Employee;
  modifiedById: string;
  modifiedViaId: string;

  constructor(jsonData?: Partial<EboEventTo>) {
    super(jsonData);
    if (jsonData) {
      if (jsonData.modifiedBy) this.modifiedBy = new Employee(jsonData.modifiedBy);
      if (jsonData.modifiedOn) this.modifiedOn = SDate.newUtc(jsonData.modifiedOn);
    }
  }
}
